import { Button, Loader, Modal, ModalButtons, Text } from "@eventsquare/uikit";
import { RiArrowLeftLine, RiBankCardLine } from "@remixicon/react";
import styles from "@components/PaymentModal/PaymentModal.module.scss";
import { RefObject } from "react";

interface ScanViewProps {
  isVisible: boolean;
  cameraActive: boolean;
  totalPrice: number | string;
  videoRef: RefObject<HTMLVideoElement>;
  canvasRef: RefObject<HTMLCanvasElement>;
  onClose: () => void;
}

const ScanView = ({
  isVisible,
  cameraActive,
  totalPrice,
  videoRef,
  canvasRef,
  onClose,
}: ScanViewProps) => {
  return (
    <Modal isVisible={isVisible}>
      <div className={styles.scan}>
        {!cameraActive && (
          <div className={styles.loader}>
            <Loader size="medium" />
          </div>
        )}
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted
          className={styles.video}
          aria-label="QR code scanner"
        />
        <canvas ref={canvasRef} style={{ display: "none" }} />
        {cameraActive && (
          <div className={styles.overlay}>
            Scan
            <br />
            Wallet
          </div>
        )}
      </div>
      <div className={styles.payInfo}>
        <Text variant="h3" noMargin>
          Total due
        </Text>
        <Text variant="h2" noMargin>
          € {totalPrice}
        </Text>
      </div>
      <ModalButtons>
        <Button block>
          <RiBankCardLine /> with card
        </Button>
        <Button block variant="outline" onClick={onClose}>
          <RiArrowLeftLine /> Cancel
        </Button>
      </ModalButtons>
    </Modal>
  );
};

export default ScanView;
